<section class="cookie-content container py-4">

  <div class="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3">
    <div>
      <h1 class="c-g-headers fw-bold fs-3 mb-2 wrapper-header">Privacy and cookies</h1>
      <p class="mb-0" style="max-width: 680px;">
        We use cookies to make your website experience as smooth and enjoyable as possible.
        You can switch off optional cookies below and hit 'Save preferences'.
        Disabling some optional cookies could affect your browsing experience.
      </p>
    </div>
    <img src="assets/images/cookies.jpg" alt="" aria-hidden="true"
         style="width: 200px; flex-shrink: 0;"/>
  </div>

  <hr/>

  <!-- Essential cookies (always on, collapsible info only) -->
  <div class="mb-2">
    <button class="btn btn-link p-0 text-decoration-none fw-bold fs-5 c-g-headers d-flex align-items-center gap-2 cgp-link"
            type="button"
            (click)="toggleExpanded(essentialCategory)"
            [attr.aria-expanded]="essentialCategory.expanded()">
      <h3 class="mb-0">Essential Cookies</h3>
      <span class="credits-chevron" [class.collapsed]="!essentialCategory.expanded()">&nbsp;</span>
    </button>

    @if (essentialCategory.expanded()) {
      <div class="mt-2">
        @if (essentialCategory.description) {
          <p class="small mb-3">{{ essentialCategory.description }}</p>
        }
        <div class="table-responsive">
          <table class="table table-bordered table-sm cookie-table">
            <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Purpose</th>
              <th>Lifespan</th>
            </tr>
            </thead>
            <tbody>
              @for (cookie of essentialCategory.cookies; track cookie.name) {
                <tr>
                  <td>{{ cookie.name }}</td>
                  <td>{{ cookie.purpose }}</td>
                  <td>{{ cookie.duration }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>

  <hr/>

  <h4 class="fs-5 fw-bold mt-4 mb-3">Optional Cookies</h4>

  @for (category of optionalCategories; track category.id) {
    <div class="mb-3 border-bottom pb-3">

      <div class="d-flex align-items-center gap-3 mb-1">
        <span class="fw-semibold">{{ category.label }}</span>
        <div class="d-flex align-items-center gap-3">
          <div class="d-flex align-items-center gap-1">
            <input class="form-check-input mt-0" type="radio"
                   [name]="category.id"
                   [id]="category.id + '-on'"
                   [checked]="isEnabled(category.id)"
                   (change)="setConsent(category.id, true)"/>
            <label class="form-check-label" [for]="category.id + '-on'">On</label>
          </div>
          <div class="d-flex align-items-center gap-1">
            <input class="form-check-input mt-0" type="radio"
                   [name]="category.id"
                   [id]="category.id + '-off'"
                   [checked]="!isEnabled(category.id)"
                   (change)="setConsent(category.id, false)"/>
            <label class="form-check-label" [for]="category.id + '-off'">Off</label>
          </div>
        </div>
      </div>

      <button class="btn btn-link p-0 text-decoration-none fw-bold fs-5 c-g-headers d-inline-flex align-items-center gap-2 cgp-link fs-14"
              type="button"
              (click)="toggleExpanded(category)">
        @if (category.expanded()) {
          Less <span class="credits-chevron cgp-link">&nbsp;</span>
        } @else {
          More <span class="credits-chevron collapsed cgp-link">&nbsp;</span>
        }
      </button>

      @if (category.expanded()) {
        <div class="mt-2">
          @if (category.description) {
            <p class="small mb-2">{{ category.description }}</p>
          }
          @if (category.cookies.length > 0) {
            <div class="table-responsive">
              <table class="table table-bordered table-sm cookie-table">
                <thead>
                <tr>
                  <th>Cookie Name</th>
                  <th>Purpose</th>
                  <th>Lifespan</th>
                </tr>
                </thead>
                <tbody>
                  @for (cookie of category.cookies; track cookie.name) {
                    <tr>
                      <td>{{ cookie.name }}</td>
                      <td>{{ cookie.purpose }}</td>
                      <td>{{ cookie.duration }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      }

    </div>
  }

  <div class="d-flex gap-2 mt-4 flex-wrap">
    <button class="btn btn-default" type="button" (click)="savePreferences()">Save preferences</button>
    <button class="btn btn-default" type="button" (click)="rejectAll()">Reject all</button>
    <button class="btn btn-default" type="button" (click)="acceptAll()">Accept all</button>
  </div>

</section>
